import { CreatePasswordFormComponent } from '../../../../forms/dynamic-forms/create-password-form/create-password-form.component';
import { ChangePasswordFormComponent } from '../../../../forms/dynamic-forms/change-password-form/change-password-form.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute , RouterModule } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { AcmicService, User } from '@mapfre-design-library/src/public_api';
import { EditPasswordService } from '../../../../../_services/forms/profile-settings/edit-password.service';
import { CreateNewPasswordFormService } from '@services/forms/forgot-password/create-new-password-form/create-new-password-form.service';
import { UserDataService } from './../../../../../_services/data-services/user-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, ChangePasswordFormComponent, CreatePasswordFormComponent],
  selector: 'app-profile-edit-password',
  templateUrl: './profile-edit-password.component.html',
  providers: [EditPasswordService],
})
export class ProfileEditPasswordComponent implements OnInit {
  changePassword: any[];
  user: User = {};
  whereInTheProcess: string;
  isAcmic = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    private createPasswordService: CreateNewPasswordFormService,
    private passwordService: EditPasswordService,
    private userDataService: UserDataService,
    private acmicService: AcmicService
  ) {}

  whereInTheProcessTitle(): string {
    if (this.whereInTheProcess === 'enter-password') {
      return 'PROFILE_EMAIL_THREE';
    } else if (this.whereInTheProcess === 'edit-password') {
      return 'PROFILE_PASSWORD_TWO';
    } else {
      return 'PROFILE_PASSWORD_ONE';
    }
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.userDataService.$userData.subscribe((user) => {
      this.user = user;
      localStorage.setItem('createuserinfo', JSON.stringify(user));
    });

    this.whereInTheProcess = this.activatedRoute.snapshot.routeConfig.path;
    if (this.whereInTheProcess === 'enter-password') {
      this.changePassword = this.passwordService.getInputs('changePassword');
    } else if (this.whereInTheProcess === 'edit-password') {
      this.changePassword = this.createPasswordService.getInputs(
        'changeAccountPassword'
      );
    }
  }

}
